import React, { useState } from 'react';
import { SCREEN_TYPES } from 'utils/constants';
import { useAppStore, useReceiptStore } from 'store';
import { Button } from 'components/ui/Button';
import { CardTitle } from 'components/ui/card';
import { closeCurrentReceipt } from 'utils/closeReceiptAction';

export default function ConfirmClose() {
  const [loading, setLoading] = useState(false);
  const { setCurrentScreen } = useAppStore();
  const { receiptData } = useReceiptStore();

  const onCancel = () => setCurrentScreen(SCREEN_TYPES.SCAN_BOX);

  const handleClose = async (): Promise<void> => {
    setLoading(true);
    const success = await closeCurrentReceipt();
    if (!success) setLoading(false);
  };

  const expectedTotal =
    receiptData?.lines?.filter((line) => line && line.expected_ind === 'y').length || 0;
  const actualScanned =
    receiptData?.lines?.filter((line) => line && line.receipt_ind === 'y').length || 0;
  const expectedScanned =
    receiptData?.lines?.filter(
      (line) => line && line.expected_ind === 'y' && line.receipt_ind === 'y'
    ).length || 0;
  const unexpectedScanned =
    receiptData?.lines?.filter(
      (line) => line && line.expected_ind === 'n' && line.receipt_ind === 'y'
    ).length || 0;
  const fraudScanned = 0;

  return (
    <div className="flex flex-col gap-3">
      <CardTitle className="text-center text-lg font-extrabold tracking-tight text-slate-900">
        CONFIRM CLOSE
      </CardTitle>

      <div className="rounded-xl border border-slate-200 bg-slate-50 px-3 py-2 text-xs">
        <span className="font-semibold text-slate-500">Tracking: </span>
        <span className="font-semibold text-slate-900 break-all">
          {receiptData?.tracking_id || receiptData?.receipt?.tracking_id}
        </span>
      </div>

      <div className="rounded-xl border border-slate-200 bg-white p-3 shadow-sm">
        <div className="mb-2 text-xs font-semibold uppercase tracking-wide text-slate-500">
          Summary
        </div>
        <div className="grid grid-cols-2 gap-2 text-sm">
          <Stat label="Expected Total" value={expectedTotal} />
          <Stat label="Actual Scanned" value={actualScanned} />
          <Stat label="Expected Scanned" value={expectedScanned} />
          <Stat label="Unexpected" value={unexpectedScanned} />
          <Stat label="Fraud Scanned" value={fraudScanned} />
        </div>
      </div>

      <div className="buttons-container">
        <Button
          type="button"
          variant="outline"
          onClick={onCancel}
          disabled={loading}
          className="h-11 flex-1 rounded-xl border-2 border-red-600 text-sm font-semibold text-red-600 hover:bg-red-50"
        >
          Cancel
        </Button>
        <Button
          type="button"
          onClick={handleClose}
          disabled={loading}
          className="h-11 flex-1 rounded-xl text-sm font-semibold shadow-sm"
        >
          {loading ? 'Closing...' : 'CLOSE'}
        </Button>
      </div>
    </div>
  );
}

const Stat = ({ label, value }: { label: string; value: number }) => (
  <div className="flex items-center justify-between">
    <span className="text-xs text-slate-600">{label}</span>
    <span className="font-bold text-slate-900">{value}</span>
  </div>
);
